// extracted by mini-css-extract-plugin
export default {"floor-container":"BuildingFloor_floor-container__iLa21","floor-cell":"BuildingFloor_floor-cell__Dh-iO","btn-delete":"BuildingFloor_btn-delete__T9la4"};